export const BUY_GET_REQUEST = "BUY_GET_REQUEST";
export const BUY_GET_SUCCESS = "BUY_GET_SUCCESS";
export const BUY_GET_FAILURE = "BUY_GET_FAILURE";